export default {"src":"/_next/static/media/finnacialServices.59aedd1a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};